import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import adminApi from "@/lib/adminApi";
import { Panel, StatusBadge, timeAgo } from "@/components/admin/ui";

const KIND_LABELS = { email: "E-mail", sms: "SMS", whatsapp: "WhatsApp", internal: "Interne" };

export default function AdminCommunications() {
  const [comms, setComms] = useState(null);

  useEffect(() => {
    adminApi.get("/communications").then((r) => setComms(r.data.communications)).catch(() => {});
  }, []);

  return (
    <div className="space-y-4" data-testid="admin-communications">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-ink">Communications</h1>
        <p className="mt-0.5 text-sm text-slate">Historique de tous les envois clients — e-mails en production, SMS/WhatsApp prêts à connecter.</p>
      </div>
      <Panel testId="communications-list">
        {!comms && <div className="h-40 animate-pulse rounded bg-cloud" />}
        {comms?.length === 0 && <p className="py-8 text-center text-sm text-slate" data-testid="communications-empty">Aucune communication envoyée pour l’instant.</p>}
        <div className="divide-y divide-slate/10">
          {comms?.map((c) => (
            <div key={c.id} className="flex items-center justify-between gap-3 py-2.5 text-sm">
              <span className="flex min-w-0 items-center gap-3">
                <span className="w-16 shrink-0 rounded bg-cloud px-2 py-0.5 text-center text-xs font-medium text-slate">{KIND_LABELS[c.kind] || c.kind}</span>
                <span className="truncate text-ink">{c.subject || c.template}</span>
                <span className="hidden truncate text-slate md:inline">→ {c.to}</span>
              </span>
              <span className="flex shrink-0 items-center gap-3">
                {c.tracking_code && (
                  <Link to={`/admin/app/bookings/${c.tracking_code}`} className="font-mono text-xs text-miles hover:underline">{c.tracking_code}</Link>
                )}
                <StatusBadge status={c.status} />
                <span className="w-20 text-right font-mono text-[11px] text-slate">{timeAgo(c.at)}</span>
              </span>
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
}
